// extracted by mini-css-extract-plugin
module.exports = {"buoyCardData":"BuoyCardData_buoyCardData__sbE__","buoyCardDataLarge":"BuoyCardData_buoyCardDataLarge__Vzo6h"};